
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"31","fill":"none","stroke":"#292D32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.25 9.248a.782.782 0 00-.245 0A3.324 3.324 0 0119.8 5.916a3.324 3.324 0 013.333-3.333 3.332 3.332 0 013.332 3.333 3.344 3.344 0 01-3.216 3.332zM21.92 18.652c1.77.297 3.72-.013 5.089-.93 1.821-1.215 1.821-3.204 0-4.418-1.382-.917-3.358-1.227-5.128-.917M7.711 9.248a.782.782 0 01.246 0 3.324 3.324 0 003.203-3.332 3.324 3.324 0 00-3.333-3.333 3.332 3.332 0 00-3.332 3.333 3.344 3.344 0 003.216 3.332zM9.042 18.652c-1.77.297-3.72-.013-5.09-.93-1.82-1.215-1.82-3.204 0-4.418 1.383-.917 3.359-1.227 5.128-.917M15.5 18.897a.783.783 0 00-.245 0 3.324 3.324 0 01-3.204-3.332 3.324 3.324 0 013.333-3.333 3.332 3.332 0 013.332 3.333c-.013 1.808-1.433 3.28-3.216 3.332zM11.741 22.966c-1.821 1.214-1.821 3.203 0 4.417 2.067 1.382 5.451 1.382 7.518 0 1.821-1.214 1.821-3.203 0-4.417-2.054-1.37-5.451-1.37-7.518 0z","stroke":"inherit","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    